import { render, staticRenderFns } from "./cascader-item.vue?vue&type=template&id=38e9341f&"
import script from "./cascader-item.vue?vue&type=script&lang=js&"
export * from "./cascader-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cascader-item.vue"
export default component.exports